/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Flex, Link, Text } from '@bottlebooks/gatsby-theme-base/src';
import React, { useEffect } from 'react';
import { jsx } from 'theme-ui';
import useSiteLanguage from '../useSiteLanguage';

export default function GoogleTranslate() {
  const { lang, setLang } = useSiteLanguage();
  useEffect(() => {
    var addScript = document.createElement('script');
    addScript.setAttribute('src', '/googleTranslateLocal.js');
    document.body.appendChild(addScript);
  }, []);

  return (
    <React.Fragment>
      {lang && !['en', 'en-US'].includes(lang) && (
        <Flex
          justify="center"
          sx={{ backgroundColor: 'light', paddingY: 1, flexWrap: 'wrap' }}
          gap={2}
        >
          <Text variant="small" sx={{ color: 'brand.smoke' }}>
            This site has been automatically translated by Google
          </Text>
          <Link
            onClick={() => {
              setLang({ lang: 'en' });
            }}
          >
            <Text variant="small">Show original language</Text>
          </Link>
        </Flex>
      )}
      <Translate
        isReady={
          // window !== 'undefined is required so that SSR doesn't throw an error
          // @ts-ignore - window.cr is where googleTranslate loads automatically
          typeof window !== 'undefined' && window?.cr?.googleTranslate?.libReady
        }
      />
    </React.Fragment>
  );
}

function Translate({ isReady }) {
  const { lang } = useSiteLanguage();
  // TODO: fetch using static query
  const baseLanguage = 'en';
  if (!isReady) return null;
  if (!lang) return null;
  // @ts-ignore - window.cr is where googleTranslate loads automatically
  if (lang === baseLanguage) window.cr.googleTranslate.revert();
  // @ts-ignore - window.cr is where googleTranslate loads automatically
  else window.cr.googleTranslate.translate(baseLanguage, lang);
  return null;
}
